import React, { Component } from 'react'

// Elements
import Button from '../button'

import './bottomBar.scss'
// import { translation } from '../../../../utils/helpers'

class BottomBar extends Component {
  constructor (props) {
    super(props)
    this.state = {}
  }

  render () {
    const {
      disabled,
      center,
      actionStyle,
      cancelStyle,
      actionLabelText,
      onActionClick,
      cancelLabelText,
      onCancelClick
    } = this.props

    let extraClass = ''
    if (disabled) extraClass = ' disabled'
    if (this.props.className != null) {
      extraClass += ' ' + this.props.className
    }

    let cancelBtn = <Button
      style={cancelStyle}
      spacing={0}
      size='l'
      onClick={onCancelClick}
      labelText={cancelLabelText}
      setFocus={false}
    />

    let acceptBtn = <Button
      style={actionStyle}
      spacing={0}
      size='l'
      onClick={onActionClick}
      disabled={disabled}
      labelText={actionLabelText}
      setFocus
    />

    return (
      <div className={'element-bottom-bar' + extraClass}>
        {actionLabelText && !center && (
          acceptBtn
        )}
        {(this.props.children || center) && (
          <div className='center-buttons'>
            {actionLabelText && center && acceptBtn}
            {this.props.children}
            {cancelLabelText && center && cancelBtn}
          </div>
        )}
        {cancelLabelText && !center && (
          <div className='right'>
            {cancelBtn}
          </div>
        )}
      </div>
    )
  }
}

BottomBar.defaultProps = {
  disabled: false,
  center: false,
  actionStyle: 'primary',
  cancelStyle: 'anchor',
  actionLabelText: null,
  cancelLabelText: null,
  onActionClick: () => {},
  onCancelClick: () => {}
}

export default BottomBar



// WEBPACK FOOTER //
// ./src/app/shared/elements/bottomBar/index.js